export default function LoadingGame({ mode }) {
    return (
        <div className={`text-xl ${mode === "dark" ? "text-white" : "text-black"} flex items-center`}>
            <span className="animate-pulse">Loading Game</span>
            <span className="dot-flash ml-1">.</span>
            <span className="dot-flash ml-1 delay-200">.</span>
            <span className="dot-flash ml-1 delay-400">.</span>
        </div>
    );
}
